import React, {Component} from 'react';
import {withTranslation} from "react-i18next";
import {connect} from 'react-redux';
import {PolIcon} from "../../PolIcon/policon";
import MenuUser from "./menuUser";
import UserService from "../../../api/user/user";
import {logOut} from "../../../actions/user";
import {postAdmin} from "../../../api/datas/post";
import ReactTooltip from 'react-tooltip';
import sfi from '../../../img/logoSFI.png'
import PolPopup from "v4/components/ui/PolPopup/PolPopup";
import A11yPopup from "v4/features/front/a11y/components/A11yPopup/A11yPopup";

class User extends Component {
    constructor(props) {
        super(props);
        this.state = {
            expandUser: false,
            user: {},
            spfCheck: false
        };
    }

    componentDidMount() {
        const {logOut} = this.props;

        let localUser = UserService.getUser();
        if (localUser) {
            postAdmin('/api/spf_checks', () => {
                this.setState({
                    spfCheck: false
                })
            }, (data) => {
                if (data) {
                    this.setState({
                        spfCheck: data.spfResult
                    })
                }
            })

        } else {
            logOut();
        }

        this.setState({
            user: localUser,
            isA11yPopupOpen: false,
        })
    }

    handleUserMenuClick = () => {
        // if the menu is open, do nothing, the event listener will close it
        if (this.state.expandUser) return;

        // open the menu
        this.setState({expandUser: true});

        // close the menu when clicking anywhere
        document.addEventListener(
            'click',
            () =>this.setState({expandUser: false}),
            {once: true}
        );
    }

    openA11yPopup = () => {
        this.setState({isA11yPopupOpen: true});
    }

    closeA11yPopup = () => {
        this.setState({isA11yPopupOpen: false});
    }

    render() {
        const {t} = this.props;
        const {expandUser, user, spfCheck, isA11yPopupOpen} = this.state;

        return (
            <div className={'row align-items-end user__content'}>
                <div className={'col-auto'}>
                    <img src={user.customer && user.customer.logoUrl ? user.customer.logoUrl : sfi} alt={'Logo'}/>
                </div>
                <div className={'col d-none d-md-block'}
                     onClick={this.handleUserMenuClick}>
                    <p className={'user__title'}>{t('bienvenue')}</p>
                    <p className={'user__text'}>
                        {!spfCheck ? (
                            <PolIcon data-tip={t('spf_check_fail')} icon={'exclamation-circle'}
                                     data-for='tooltip-user'
                                     className={'user__warning'}/>) : null}
                        {user.firstname} {user.lastname}
                        <PolIcon icon={'chevron-down'} className={`user__menu ${expandUser ? 'active-menu' : ''}`}/>
                    </p>

                    {expandUser ?
                        <div className={'user__actions'}>
                            <MenuUser openA11yPopup={this.openA11yPopup}/>
                        </div> : null
                    }
                </div>
                <ReactTooltip effect="solid" id={'tooltip-user'}/>

                <PolPopup title={t('accessibility')} isOpen={isA11yPopupOpen} closePopup={this.closeA11yPopup}>
                    <A11yPopup closePopup={this.closeA11yPopup}/>
                </PolPopup>
            </div>
        );
    }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => {
    return {
        logOut: () => dispatch(logOut()),
    }
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withTranslation()(User));

